//import * as es6promise  from 'es6-promise';
//import  "whatwg-fetch";
//import  "html5-history-api";
// To add to window
//es6promise.polyfill(); 
// let ps = [Promise.resolve(null)];
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function step1() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            // if (!Object.assign) {
            //     await import("core-js/fn/object/assign")
            // }
            if (typeof Object.assign != 'function') {
                // Must be writable: true, enumerable: false, configurable: true
                Object.defineProperty(Object, "assign", {
                    value: function assign(target, varArgs) {
                        'use strict';
                        if (target == null) { // TypeError if undefined or null
                            throw new TypeError('Cannot convert undefined or null to object');
                        }
                        var to = Object(target);
                        for (var index = 1; index < arguments.length; index++) {
                            var nextSource = arguments[index];
                            if (nextSource != null) { // Skip over if undefined or null
                                for (var nextKey in nextSource) {
                                    // Avoid bugs when hasOwnProperty is shadowed
                                    if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                                        to[nextKey] = nextSource[nextKey];
                                    }
                                }
                            }
                        }
                        return to;
                    },
                    writable: true,
                    configurable: true
                });
            }
            return [2 /*return*/];
        });
    });
}
function step2() {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!!history.pushState) return [3 /*break*/, 2];
                    return [4 /*yield*/, import("html5-history-api")];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2:
                    if (!!window.fetch) return [3 /*break*/, 4];
                    return [4 /*yield*/, import("whatwg-fetch")];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4:
                    if (!!document.head.classList) return [3 /*break*/, 6];
                    return [4 /*yield*/, import("classlist-polyfill")];
                case 5:
                    _a.sent();
                    _a.label = 6;
                case 6:
                    if (ko && !ko.expressionRewriting.writeValueToProperty)
                        ko.expressionRewriting.writeValueToProperty = ko.expressionRewriting["Za"] || ko.expressionRewriting["Ga"] || ko.expressionRewriting["$a"];
                    return [2 /*return*/];
            }
        });
    });
}
var hasPerformance = !!(window.requestAnimationFrame);
if (!hasPerformance) {
    window.requestAnimationFrame = function (callback) {
        setTimeout(function () {
            callback(0);
        }, 10);
        return 0;
    };
}
if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
        return this.substr(position || 0, searchString.length) === searchString;
    };
}
String.prototype["hashCode"] = function () {
    var hash = 0, i, chr;
    if (this.length === 0)
        return hash;
    for (i = 0; i < this.length; i++) {
        chr = this.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    if (hash < 0)
        hash = -hash;
    return hash;
};
export default step1().then(step2);
//import * as es6promise  from 'es6-promise';
//import  "whatwg-fetch";
//import  "html5-history-api";
// To add to window
//es6promise.polyfill(); 
// let ps = [Promise.resolve(null)];
// async function step1() {
//     // if (!Object.assign) {
//     //     await import("core-js/fn/object/assign")
//     // }
//     if (typeof Object.assign != 'function') {
//         // Must be writable: true, enumerable: false, configurable: true
//         Object.defineProperty(Object, "assign", {
//             value: function assign(target: any, varArgs: any) { // .length of function is 2
//                 'use strict';
//                 if (target == null) { // TypeError if undefined or null
//                     throw new TypeError('Cannot convert undefined or null to object');
//                 }
//                 var to = Object(target);
//                 for (var index = 1; index < arguments.length; index++) {
//                     var nextSource = arguments[index];
//                     if (nextSource != null) { // Skip over if undefined or null
//                         for (var nextKey in nextSource) {
//                             // Avoid bugs when hasOwnProperty is shadowed
//                             if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
//                                 to[nextKey] = nextSource[nextKey];
//                             }
//                         }
//                     }
//                 }
//                 return to;
//             },
//             writable: true,
//             configurable: true
//         });
//     }
// }
// async function step2() {
//     if (!history.pushState) {
//         await import(
//             /* webpackChunkName: "polyfill" */
//             "html5-history-api")
//     }
//     if (!window.fetch) {
//         await import(/* webpackChunkName: "polyfill" */"whatwg-fetch")
//     }
//     if (!document.head.classList) {
//         await import(/* webpackChunkName: "polyfill" */"classlist-polyfill")
//     }
// }
// let hasPerformance = !!(window.requestAnimationFrame);
// if (!hasPerformance) {
//     window.requestAnimationFrame = (callback) => {
//         setTimeout(() => {
//             callback(0)
//         }, 10);
//         return 0
//     }
// }
// if (!String.prototype.startsWith) {
//     String.prototype.startsWith = function (searchString, position) {
//         return this.substr(position || 0, searchString.length) === searchString;
//     };
// }
// String.prototype["hashCode"] = function () {
//     var hash = 0, i, chr;
//     if (this.length === 0) return hash;
//     for (i = 0; i < this.length; i++) {
//         chr = this.charCodeAt(i);
//         hash = ((hash << 5) - hash) + chr;
//         hash |= 0; // Convert to 32bit integer
//     }
//     if (hash < 0) hash = -hash
//     return hash;
// };
// export default step1().then(step2)
